import { AdapterRegistry, IModel } from 'shell-models-lib';
import { Metamodel } from 'app/model/base/model';
import { DynamicsCrmSink } from 'app/model/pipeline/copysink/dynamics-crm.copysink';
import { DynamicsSinkAdapter, dynamicsSinkAdapts } from './dynamics.sink.adapter';

@AdapterRegistry.adapter({
    model: Metamodel.modelFor(DynamicsCrmSink),
    asynchronous: true,
    adapts: dynamicsSinkAdapts
})
export class DynamicsCrmSinkAdapter extends DynamicsSinkAdapter {
    protected override model(): IModel {
        return DynamicsCrmSink.MODEL;
    }
}
